export default __webpack_public_path__ + "static/21-0ffd6b8830400a8ac36b3fff28683c0d.webp";